
import { ResumeExperience } from '@/models/Resume'
import { defineComponent, PropType } from 'vue'

import ExperiencePosition from './ExperiencePosition.vue';
import ExperienceApp from './ExperienceApp.vue';

export default defineComponent({
    name: "experience",
    components: {
        // ExperienceApp
        ExperiencePosition
    },
    props: {
        experience: {
            type: Array as PropType<ResumeExperience[]>,
            required: true
        } 
    }
})
